import React from 'react'
import ProjectInfo from '../ProjectInfo'

import eclipse from "../../../../Assets/images/projects/eclipsedetailed.png"


export default function Eclipse() {
    return (
        <ProjectInfo pic={eclipse}
            title="Eclipse"
            link="https://jrwolf-eclipse.netlify.app/"
            githublink="https://github.com/Jrwolf99/Eclipse-Current"
            maincolor="#411575"
            accentcolor="#2f8cc1"
        >
            <p > This online multiplayer game is a blast to the past
                tribute to a classic ship arcade game.
                With a singleplayer version and a multiplayer version,
                players can score points by shooting space boulders.
                But... make sure to not shoot yourself in the foot or run into the boulders!
            </p>
            <br />
            <p>Created with Vanilla JS and CSS, this app was made to be played on a modern web browser.</p>
            <br />



        </ProjectInfo>
    )
}
